import { Box, Flex, GimaTag, Tag, Text } from '@/components';
import { isRS } from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  name: string;
  isIntegrated: boolean;
  isExcludedFromOptions: boolean;
};

export const OrganizationName: FC<Props> = ({
  name,
  isIntegrated,
  isExcludedFromOptions,
}) => {
  const { t } = useTranslation();

  return (
    <Flex gap={4} vertical={true}>
      <Box alignSelf="flex-start">
        <Flex gap={4}>
          <GimaTag isIntegrated={isIntegrated} />
          {isRS() && isExcludedFromOptions && (
            <Tag color="error">{t('is-excluded-from-options')}</Tag>
          )}
        </Flex>
      </Box>
      <Text weight="regular" text={name} />
    </Flex>
  );
};
